import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const EDCStatCard = ({ icon: Icon, label, value, color = "primary", to, hint }) => {
  const body = (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: `${color}.main`,
              color: `${color}.contrastText`,
              flexShrink: 0,
            }}
          >
            <Icon />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h5" fontWeight={700}>
              {value ?? "—"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
            {hint ? (
              <Typography variant="caption" color={`${color}.main`}>
                {hint}
              </Typography>
            ) : null}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );

  return to ? (
    <Box
      component={RouterLink}
      to={to}
      sx={{ textDecoration: "none", display: "block", height: "100%" }}
    >
      {body}
    </Box>
  ) : (
    body
  );
};

export default EDCStatCard;
